import React, { useEffect, useState } from 'react';
import { getNameClient } from './../../../helpers/nameClient';
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Col, Container } from 'reactstrap';
import Swal from 'sweetalert2';

import { getConfigTask, addConfigTask, updateConfigTask, deleteConfigTask } from '../../../store/ConfigTasks/actions';

import Breadcrumbs from '../../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../../components/Common/iComponents/iPopUp/IpopUp';
import FormConfigTask from './form-configTask';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import { ISelector } from '../../../components/Common/iComponents/iSelector/iSelector';
import { getClients, getTasks } from '../../../store/actions';
import usePageTitle from '../../../common/hooks/usePageTitle';

const ConfigTaskList = (props: any) => {
    const dispatch = useDispatch();

    const valuesSizeTareasPagination = [100];
    const [, setPaginationTasks] = useState<any>({
        sizePerPage: valuesSizeTareasPagination[0],
        page: 1,
    });

    const valuesSizeClientsPagination = [100,120,130,140,150];
    const [, setPaginationClients] = useState<any>({
        sizePerPage: valuesSizeClientsPagination[0],
        page: 1,
    });

    const PageTitleConfigTask = usePageTitle(props.location.pathname);

    const { configTasks, CountItems } = useSelector((state: any) => state.ConfigTasks);

    const [tableViewList] = useState([]);
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const valuesSizePagination = [10, 20, 30, 40, 50, 100];
    const [pagination, setPagination] = useState<any>({
        sizePerPage: valuesSizePagination[0],
        page: 1,
    });
    const { clients } = useSelector((state: any) => state.clients);
    const { tasks, countItems: CountItemsTask } = useSelector((state: any) => state.Tasks);

    const [arrayTableColumns, setArrayTableColumns] = useState<any>([]);
    const [queryObject, setQueryObject] = useState<any>({});
    const [queryString, setQueryString] = useState<any>({});

    const [listDataState, setListDataState] = useState([]);

    const initialArrayTableClients = [
        {
            text: 'Id',
            dataField: 'id',
            formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
            hidden: false,
        },
        {
            text: 'Name',
            dataField: 'name',
            formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
            hidden: false,
        },
    ];

    const initialArrayTableTareas = [
        {
            text: 'Id',
            dataField: 'id',
            formatter: (cellContent: any, tasks: any) => <>{tasks.id}</>,
            hidden: false,
        },
        {
            text: 'Description',
            dataField: 'descripcion',
            formatter: (cellContent: any, tasks: any) => <>{tasks.descripcion}</>,
            hidden: false,
        },
    ];

    useEffect(() => {
        setListDataState(configTasks);
    }, [configTasks, tasks, pagination]);

    useEffect(() => {
        let initialArrayTable;
        if (tasks.length !== 0) {
            initialArrayTable = [
                {
                    text: 'empresa',
                    dataField: 'empresa',
                    formatter: (cellContent: any, configTask: any) => <>{configTask.empresa}</>,
                    hidden: true,
                },
                {
                    text: 'Cliente',
                    dataField: 'clienteId',
                    sort: true,
                    formatter: (cellContent: any, configTask: any) => {
                        const data = clients.find((client: any) => client.id === configTask.clienteId);
                        const desc = data?.name;
                        return <>{`${configTask.clienteId} - ${desc}`}</>;
                    },

                    hidden: false,
                },
                {
                    text: 'Tarea',
                    dataField: 'tareaId',
                    sort: true,
                    formatter: (cellContent: any, configTask: any) => {
                        const data = tasks.find((tasks: any) => tasks.id === configTask.tareaId);
                        const desc = data?.descripcion;
                        return <>{`${configTask.tareaId} - ${desc}`}</>;
                    },

                    hidden: false,
                },
                {
                    text: 'Frecuencia',
                    dataField: 'repetirCada',
                    formatter: (cellContent: any, configTask: any) => <>{configTask.repetirCada}</>,
                    hidden: false,
                    sort: true,
                },
                {
                    text: 'Enabled',
                    dataField: 'enabled',
                    formatter: (cellContent: any, configTask: any) => {
                        return (
                            <ISwitch
                                checked={configTask.enabled}
                                onChangeBooleanHandler={(args:any) => { 
                                    const newObject = { ...configTask };
                                    newObject.enabled = args;
                                    dispatch(
                                        updateConfigTask({
                                            ConfigTask: newObject,
                                            pagination,
                                            data: queryString,
                                        }),
                                    );
                                }}
                            />
                        );
                    },
                    hidden: false,
                },
                {
                    text: 'Workflow',
                    dataField: 'workflow',
                    formatter: (cellContent: any, configTask: any) => {
                        return (
                            <ISwitch
                                checked={configTask.workflow}
                                onChangeBooleanHandler={(args:any) => {
                                    const newObject = { ...configTask };
                                    newObject.workflow = args;
                                    dispatch(
                                        updateConfigTask({
                                            ConfigTask: newObject,
                                            pagination,
                                            data: queryString,
                                        }),
                                    );
                                }}
                            />
                        );
                    },
                    hidden: false,
                },
            ];
        }

        setArrayTableColumns(initialArrayTable ?? []);
    }, [dispatch, tasks, clients, configTasks, queryString]);

    useEffect(() => {
        dispatch(getClients({}));
        dispatch(getTasks(CountItemsTask));
        dispatch(getConfigTask({ pagination, data: queryString }));
    }, [dispatch, pagination]);

    useEffect(() => {
        dispatch(getConfigTask({ pagination, data: queryString }));
    }, [dispatch, pagination, queryString]);

    const handleCreateConfigTask = (ConfigTask: any) => {
        setpopUpState(!popUpState);
        dispatch(addConfigTask({ ConfigTask, pagination }));
        Swal.fire({
            icon: 'success',
            title: 'Added!!!',
            text: 'New items have been added successfully!!!',
        });
    };

    const handleUpdateConfigTask = (ConfigTask: any) => {
        setpopUpState(!popUpState);
        dispatch(updateConfigTask({ ConfigTask, pagination, data: queryString }));
        dispatch(getConfigTask({ pagination, data: queryString }));
        Swal.fire({
            icon: 'success',
            title: 'Updated!!!',
            text: 'New items have been updated successfully!!!',
        });
    };

    const handleDeleteConfigTask = (id: any) => {
        Swal.fire({
            text:"Are you sure?",
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            
            customClass: {
                popup: 'large-text',
                
            },
            
            }).then((result) => {
            if (result.isConfirmed) {
                setpopUpState(!popUpState);
                dispatch(deleteConfigTask({ id, pagination }));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!!!',
                    text: 'Items have been deleted successfully!!!',
                });
            } 
            
            });
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    const handleActionOnRowClick = (row: any) => {
        setSelectedRow(row);
    };

    const handleAddAction = () => {
        setUpdateState(false);
        setpopUpState(!popUpState);
        setSelectedRow(null);
    };
    const handleCancel = () => {
        setpopUpState(!popUpState);
    };

    const handlePaginationTasksChange = (newState: any) => {
        setPaginationTasks(newState);
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const handlePaginationClientsChange = (newState: any) => {
        setPaginationClients(newState);
    };
    const onChangeSelectorHandler = (n: any, value: any) => {
        setQueryString({ ...queryString, [n]: value.id });
        setQueryObject({ ...queryObject, [n]: value });
    };

    const onChangeHandler = (e: any, n: any) => {
        if (n === 'Search Client ID') {
            const newObject = clients.filter((item: any) => Number(item.id) === Number(e.target.value))[0];
            setQueryObject({ ...queryObject, [n]: newObject });
        }

        if (n === 'Search Task ID') {
            const newObject = clients.filter((item: any) => Number(item.id) === Number(e.target.value))[0];
            setQueryObject({ ...queryObject, [n]: newObject });
        }

        setListDataState([]);
        setQueryString({ ...queryString, [n]: e.target.value });
    };

    const textClient = 'Search Client ID';
    const textTareaId = 'Search Task ID';

    const AdminFilters = () => {
        return (
            <>
                <div className="col-5">
                    <div className="justify-content-center">
                        <ISelector
                            title={textClient}
                            value={queryObject[textClient]?.id || queryString[textClient] || ''}
                            nameSelector={queryObject[textClient]?.name ?? ''}
                            valuesSizePagination={valuesSizeClientsPagination}
                            CountItems={clients?.length}
                            dataSelector={clients}
                            initialArrayTable={initialArrayTableClients}
                            handlePaginationChange={handlePaginationClientsChange}
                            setSelectedRow={onChangeSelectorHandler}
                            onChangeHandler={onChangeHandler}
                        />
                    </div>
                </div>
                <div className="col-5">
                    <div className="justify-content-center">
                        <ISelector
                            title={textTareaId}
                            value={queryObject[textTareaId]?.id || queryString[textTareaId] || ''}
                            nameSelector={queryObject[textTareaId]?.descripcion ?? ''}
                            valuesSizePagination={valuesSizeTareasPagination}
                            CountItems={CountItemsTask}
                            remote={true}
                            dataSelector={tasks}
                            initialArrayTable={initialArrayTableTareas}
                            handlePaginationChange={handlePaginationTasksChange}
                            setSelectedRow={onChangeSelectorHandler}
                            onChangeHandler={onChangeHandler}
                        />
                    </div>
                </div>
            </>
        );
    };

    return (
        <React.Fragment>
            <div id="main" style={{ overflow: 'auto' }}>
                {/* <div id="menuColumn"></div> */}
                <div id="navbar"></div>
                <div className="pageContent">
                    <PageTitle>
                        <title>{PageTitleConfigTask.replace(/-/g, ' ')} | {getNameClient()}</title>
                    </PageTitle>
                    <Container fluid>
                        <div>
                            <div className="row justify-content-center me-2">
                                <div className="d-flex justify-content-end pb-3">
                                    <button type="button" className="btn bg-primary text-white add-primary-button" onClick={handleAddAction}>
                                        + Add
                                    </button>
                                </div>
                                {AdminFilters()}
                            </div>
                        </div>

                        <Col lg="12">
                            {arrayTableColumns.length !== 0 ? (
                                <ITable
                                    valuesSizePagination={valuesSizePagination}
                                    CountItems={CountItems}
                                    //remote={true}

                                    data={listDataState}
                                    fields={arrayTableColumns}
                                    tableColumns={arrayTableColumns}
                                    pagSize={4}
                                    pageStartIn={0}
                                    showTotal={true}
                                    disablePageTitle={true}
                                    headerColorT={'bg-primary text-white'}
                                    tableViewList={tableViewList}
                                    groupName=""
                                    handlePopUpState={onPopUpState}
                                    actionOnRowClick={handleActionOnRowClick}
                                    handlerPaginationState={handlePaginationChange}
                                />
                            ) : null}
                        </Col>
                    </Container>
                </div>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={'ConfigTask'}
                modaleTitleUpdate={'Update Config Task'}
                icon="users"
                colorHeaderPop={'#101340'}
            >
                <FormConfigTask
                    selectedRow={selectedRow}
                    onCreateConfigTask={handleCreateConfigTask}
                    onUpdateConfigTask={handleUpdateConfigTask}
                    onDeleteConfigTask={handleDeleteConfigTask}
                    onCancel={handleCancel}
                />
            </IPopUp>
        </React.Fragment>
    );
};

export default ConfigTaskList;
